/**
 * This component shows or hides the progress bar during the signup process based on the computed progress.
 */
import { ProgressBar } from '@expressable/syntax-ds';
import { useSignupDirectProgress } from './useSignupDirectProgressFromRoutes';

export const SignupDirectProgress = () => {
  const { progress } = useSignupDirectProgress();

  if (progress <= 0) {
    return null;
  }

  return <ProgressBar className="w-full h-8 text-purple-300" progress={progress} />;
};
